export const config = {
    appname: 'ChanelFashion',
    client_id: '381014362969940', // App ID
    facebook_app_id: '381014362969940', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    agency_id: '',
    sponsor_id: '197696',
    bzbsUrl: 'https://apichf2.buzzebees.com',
    bzbsAddItemFromList: 'https://apichf2.buzzebees.com/api/cart/',
    // bzbsBlobUrl: 'https://buzzebees.blob.core.windows.net',
    bzbsBlobUrl: 'https://cdn.buzzebees.com/th',
    bzbsShoppingCartUrl: 'https://cartchf.buzzebees.com',
    bzbsAddItem: 'https://cartchf.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://cartchf.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://www.buzzebees.com',
    bzbsPointExpire: 'https://www.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://misc.buzzebees.com',
    bzbsGaId: '',
    liffId: '1655681971-Q5RGYOdX',
    lineVersion: '2.6.0',
    linkLineChanel: 'https://line.me/R/ti/p/@842bdgmi',
    // ------------------ End Settings ---------------------

    // ------------- Development New Settings ----------------
    newApi: 'apichf2',
    newBzbsUrl: 'https://apichf2.buzzebees.com',
    newBzbsModuleUrl: 'https://chanelmodule.buzzebees.com',
    newApiShoppingCartUrl: 'https://shoppingcartmodule12.buzzebees.com',
    newWebShoppingCartUrl: 'https://shoppingcartservice12.buzzebees.com',
    siteKey: '6LfvTIsqAAAAAN1DJHtx7Ed6iM-SQzShxzyxblz9',
    secretKey: '6LfvTIsqAAAAAHvFwfbhAffdaT0uqcuK_vLcdfXc',

    // ------------------ End new Settings ---------------------

    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
    mainConfig: {
    },
    firebase: {
        apiKey: "AIzaSyD7LmeYxKfuWHGSCNj3o18Bao5Dr_ENNv0",
        authDomain: "chanelfashion-production.firebaseapp.com",
        projectId: "chanelfashion-production",
        storageBucket: "chanelfashion-production.appspot.com",
        messagingSenderId: "315632016737",
        appId: "1:315632016737:web:d25caf81d3412e2a097920",
        measurementId: "G-503SMSVQ3S"
    },
};
